import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { InfoSheetPanel } from '@fs/zion-ui'
import { useOverlayContext } from '../../../../../shared/providers/overlayContextProvider/OverlayContext'
import ManageNamesContent from './ManageNamesContent'
import AddNamesPanel from '../../../../views/fullText/components/addNamesPanel/AddNamesPanel'
import { ADD_NAME_PANEL_REFERRERS } from '../../../../views/fullText/components/addNamesPanel/utils/utils'

const ManageNamesPanel = () => {
  const [t] = useTranslation()
  const { manageNamesOverlay } = useOverlayContext()
  const [selectedRecordId, setSelectedRecordId] = useState(null)
  return (
    <InfoSheetPanel
      {...manageNamesOverlay}
      title={t('manage-names.heading', 'Manage Names')}
      subtitle={t('manage-names.subheading', 'Add or Rearrange Names')}
      headingColor="yellow"
    >
      <ManageNamesContent setSelectedRecordId={setSelectedRecordId} />
      <AddNamesPanel referrer={ADD_NAME_PANEL_REFERRERS.MANAGE_NAMES} recordId={selectedRecordId} />
    </InfoSheetPanel>
  )
}

export default ManageNamesPanel
